module.exports = __webpack_public_path__ + "static/media/star.deca0823.svg";